import 'jquery-validation';

export default {
  init: function () {

    $("#reviewForm").validate({
      errorElement: "span",
    });

    $(':radio').change(function () {
      $(this).prop("checked", true)
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/review.js